import {NameComparator} from '../content/comparators/NameComparator';
import {AgeComparator} from '../content/comparators/AgeComparator';
import {GameContext} from '../content/GameContext';
import {DisplayType} from '../content/DisplayType';
import {HeightComparator} from '../content/comparators/HeightComparator';
import {PositionComparator} from '../content/comparators/PositionComparator';
import {TeamComparator} from '../content/comparators/TeamComparator';
import positions from "./positions.json";
import options from "./players.json";
import teams from "./teams.json";
import games from "./daily_games.json";
import leagues from "./leagues.json";
import {RonaldeHelpMessage} from './RonaldeHelpMessage';

export interface RonaldeSchema {
    id: number,
    name: string,
    age: number,
    team: number,
    height: number,
    nationality: string,
    position: string
}

const HEADSHOT_URL = "https://raw.githubusercontent.com/sports3/ronalde-images/main/players/headshot_%d.png";
const LEAGUE_LOGO_URL = "https://raw.githubusercontent.com/sports3/ronalde-images/main/leagues/logo_%d.png";
const TEAM_LOGO_URL = "https://raw.githubusercontent.com/sports3/ronalde-images/main/teams/logo_%d.png";

const START_DATE = new Date(2022, 2, 10);

export class RonaldeContext extends GameContext<RonaldeSchema> {
    constructor() {
        let schemaValues = new Map([
            ["name", {
                title: "Player",
                type: DisplayType.TEXT,
                comparator: new NameComparator(),
                columnDetails: {
                    title: "Player",
                    detailedTitle: "Player Name",
                    message: "",
                    width: 3
                }
            }],
            ["age", {
                type: DisplayType.TEXT,
                comparator: new AgeComparator(3),
                columnDetails: {
                    title: "Age",
                    detailedTitle: "Player Age",
                    message: "Within 3 for Yellow",
                    width: 1
                }
            }],
            ["team", {
                type: DisplayType.MULTI_IMAGE,
                comparator: new TeamComparator(teams),
                columnDetails: {
                    title: "Team",
                    detailedTitle: "Player Team / League",
                    message: "Same league for Yellow",
                    width: 2
                }
            }],
            ["height", {
                type: DisplayType.HEIGHT,
                comparator: new HeightComparator(3),
                columnDetails: {
                    title: "Height",
                    detailedTitle: "Player Height",
                    message: "Within 3 for Yellow",
                    width: 1
                }
            }],
            ["nationality", {
                type: DisplayType.IMAGE_WITH_BORDER,
                comparator: new NameComparator(),
                columnDetails: {
                    title: "Nationality",
                    detailedTitle: "Player Nationality",
                    message: "",
                    width: 1
                }
            }],
            ["position", {
                type: DisplayType.TEXT,
                comparator: new PositionComparator(positions),
                columnDetails: {
                    title: "Position",
                    detailedTitle: "Player Position",
                    message: "Forwards, Midfielders, Defenders (includes GK)",
                    width: 1
                }
            }],
            ["foot", {
                type: DisplayType.TEXT,
                comparator: new NameComparator(),
                columnDetails: {
                    title: "Foot",
                    detailedTitle: "Player Preferred Foot",
                    message: "",
                    width: 1
                }
            }],
        ]);
        super(START_DATE, "id", "name", schemaValues, ["name", "team", "nationality", "age", "height", "position", "foot"], "Ronalde", 6, HEADSHOT_URL, options, games, RonaldeHelpMessage, "#228B22");
    }

    protected override getImageDetails(value: any, key: string): [string[], string[]] {
        switch (key) {
            case "team":
                const team = teams[value as keyof typeof teams];
                const leagueId = team["division"] as any;
                const league = leagues[leagueId as keyof typeof leagues];
                const logos = [TEAM_LOGO_URL.replace("%d", value), LEAGUE_LOGO_URL.replace("%d", leagueId)];
                const descriptions = [team["name"], league["name"]];
                return [logos, descriptions];
            default:
                return super.getImageDetails(value, key);
        }
    }
}
